import React from "react";

export const Logo = ({ variant = "neon", className = "h-12" }) => {
  const src = variant === "gold" ? "/futra_gold_c.png" : "/futra_neon_c.png";
  return (
    <img
      src={src}
      alt="FUTRA"
      data-testid="futra-logo"
      className={`${className} w-auto object-contain select-none`}
      draggable={false}
    />
  );
};
